import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import * as React from "react";
import { BlockRenderer } from "../../components/block_renderer";
import { Jumbo, renderContents } from "../../components/jumbo";
export const NewsItem = (props)=>{
    const { headerTitle, description, phImageUrl, phImageUrlFallback, phImageUrlLarge, imageAlt, blocks, dateCreated } = props;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Jumbo, {
                title: headerTitle,
                contents: dateCreated.format("dddd D MMMM YYYY"),
                imageUrl: phImageUrl,
                imageUrlFallback: phImageUrlFallback,
                imageUrlLarge: phImageUrlLarge,
                imageAlt: imageAlt,
                size: "small"
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "intro",
                children: /*#__PURE__*/ _jsx("div", {
                    className: "intro__inner container--sg align--center",
                    children: description.toString().length > 0 && /*#__PURE__*/ _jsx("div", {
                        className: "intro__text text--l text--styled",
                        children: renderContents(description, /*#__PURE__*/ _jsx("div", {}), /*#__PURE__*/ _jsx("div", {}))
                    })
                })
            }),
            /*#__PURE__*/ _jsx(BlockRenderer, {
                blocks: blocks
            })
        ]
    });
};
